/* eslint-disable import/prefer-default-export */
const userFormSchema = {
  type: 'object',
  required: ['email'],
  properties: {
    email: { type: 'string', format: 'email' },
    fullName: { type: 'string', minLength: 6, maxLength: 255 },
  },
  allOf: [
    {
      if: {
        anyOf: [
          {
            not: {
              required: ['id'],
            },
          },
          {
            required: ['password'],
          },
          {
            required: ['passwordConfirmation'],
          },
        ],
      },
      then: {
        allOf: [
          {
            required: ['password', 'passwordConfirmation'],
            properties: {
              password: {
                type: 'string',
                minLength: 6,
                maxLength: 255,
              },
              passwordConfirmation: {
                type: 'string',
                const: {
                  $data: '1/password',
                },
                errorMessage: {
                  const: 'should match password',
                },
              },
            },
          },
        ],
      },
    },
  ],
};

export default userFormSchema;
